function treatAsUTC(date: string) {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result.getTime();
}

export function daysBetween(startDate: string, endDate: string): number {
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
}

const getStayLength = (startDate: string, endDate: string): number => {
    if (!startDate || !endDate) throw new Error("startDate and endDate are mandatory")
    const stayLength = Math.round(daysBetween(
        startDate,
        endDate,
    ))
    return stayLength || 1
}

export default getStayLength